import React from 'react';

import {
  ScrollToTopOnMount,
  Body,
  ExtendedFlex,
  Heading,
} from '../coreui';

const linkStyle = {
  color: '#176DB6',
  textDecoration: 'none',
};
const italicized = {
  fontStyle: 'italic',
  fontWeight: 'bold',
};

const mrIICircular = 'https://www.realtymogul.com/materials/mr2/offering_circular.pdf';
const mrICircular = 'https://www.realtymogul.com/mogul-reit-offering-circular';


export const Disclosure = () => {
  return (
    <ExtendedFlex
      bg="#FFFFFF"
      flexDirection="column"
      justify="center"
      align="left"
      px="10%"
      py="5%"
      w={1}
    >
      <ScrollToTopOnMount />
      <Body type="B3"><Heading type="H6">Disclosure</Heading>
        <br /><br />
       RealtyMogul.com is a real estate crowdfunding website operated by RM Technologies, LLC,
       a subsidiary of Realty Mogul, Co. (collectively with its affiliates, {'"RealtyMogul"'}).
       Equity securities are offered through North Capital Private Securities Corp. ({'"NCPS"'}),
       a registered broker-dealer and member <a style={linkStyle} href="http://www.finra.org/">FINRA</a>
       /<a style={linkStyle} href="http://www.sipc.org/">SIPC</a>.
        <br /><br />
       By accessing this site and any pages thereof, you agree to be bound by our
        <a style={linkStyle} href="https://www.realtymogul.com/terms-service"> Terms of Service</a> and
        <a style={linkStyle} href="https://www.realtymogul.com/privacy-policy"> Privacy Policy</a>.
        <br /><br />
       An investment in the common shares of MogulREIT I, LLC involves substantial risks.
       MogulREIT I, LLC has filed an <a style={linkStyle} href={mrICircular}>offering circular (the {'"MR I Offering Circular"'})</a> with the SEC for the offering to which
       this communication relates. Each investor should carefully consider the risk factors
       discussed in the <a style={linkStyle} href={mrICircular}>MR I Offering Circular </a>
       before purchasing shares. A copy of MogulREIT I,
       LLC’s most recent version of the
        <a style={linkStyle} href={mrICircular}> MR 1 Offering Circular</a> and any supplements
       may also be
       obtained for free on the Securities and Exchange Commission’s website at www.sec.gov.
       Some statements in the <a style={linkStyle} href={mrICircular}>MR I Offering Circular</a>,
       and on RealtyMogul.com may contain forward-
       looking statements and are based upon our current expectations, plans, estimates,
       assumptions and beliefs that involve numerous risks and uncertainties. Although we
       believe that the expectations reflected in such forward-looking statements are based
       on reasonable assumptions, actual results and performance could differ materially from
       those set forth in the forward-looking statements. An investment in MogulREIT I, LLC
       entails risk of loss, and you may lose all or part of your investment.
        <br /><br />
       NCPS is paid compensation by RealtyMogul for its role in the sale of securities of
       MogulREIT I, LLC. In addition, several officers and employees of RealtyMogul are registered
       representatives of NCPS and will realize compensation through NCPS as a result of
       MogulREIT I, LLC transactions conducted by NCPS.
        <br /><br />
       An investment in the common shares of MogulREIT II, LLC involves substantial risks.
       MogulREIT II, LLC has filed an <a style={linkStyle} href={mrIICircular}>offering circular (the {'"MR II Offering Circular"'})</a> with the SEC for the offering to which
       this communication relates. Each investor should carefully consider the risk factors
       discussed in the <a style={linkStyle} href={mrIICircular}>MR II Offering Circular </a>
       before purchasing shares. A copy of MogulREIT II,
       LLC’s most recent version of the
        <a style={linkStyle} href={mrIICircular}> MR II Offering Circular</a> and any
       supplements may also be
       obtained for free on the Securities and Exchange Commission’s website at www.sec.gov.
       Some statements in the <a style={linkStyle} href={mrIICircular}>MR II Offering Circular</a>,
       and on RealtyMogul.com may contain forward-
       looking statements and are based upon our current expectations, plans, estimates,
       assumptions and beliefs that involve numerous risks and uncertainties. Although we
       believe that the expectations reflected in such forward-looking statements are based
       on reasonable assumptions, actual results and performance could differ materially from
       those set forth in the forward-looking statements. An investment in MogulREIT II, LLC
       entails risk of loss, and you may lose all or part of your investment.
        <br /><br />
       NCPS is paid compensation by RealtyMogul for its role in the sale of securities of
       MogulREIT II, LLC. In addition, several officers and employees of RealtyMogul are registered
       representatives of NCPS and will realize compensation through NCPS as a result of
       MogulREIT II, LLC transactions conducted by NCPS.
        <br /><br />
       Any financial projections or returns shown on the website are illustrative examples
       only, and there can be no assurance that any real estate valuations provided are
       accurate or in agreement with market or industry valuations. Any investment information
       contained herein has been secured from sources RealtyMogul believes are reliable, but
       we make no representations or warranties as to the accuracy of such information and
       accept no liability therefor. Offers to sell, or the solicitations of offers to buy,
       any security can only be made through official offering documents that contain
       important information about risks, fees and expenses. Investors should conduct their
       own due diligence, not rely on the financial assumptions or estimates displayed on this
       website, and are encouraged to consult with a financial advisor, attorney, accountant,
       and any other professional that can help you to understand and assess the risks
       associated with any investment opportunity.
        <br /><br />
       Articles or information from third-party sources outside of this domain may discuss
       RealtyMogul or relate to information contained herein, but RealtyMogul does not approve
       and is not responsible for such content. Hyperlinks to third-party sites, or reproduction
       of third-party content, do not constitute an approval or endorsement by RealtyMogul or
       NCPS of the linked or reproduced content.
        <br /><br />
        Realty Mogul Commercial Capital, Co., an affiliate of Realty Mogul, Co., operates in
        California under BRE license #02003246 and CFL license #60DBO 54879.
        <br /><br />
        <Body type="B3" style={italicized}>Private Placements</Body>
        <br /><br />
       Private placements on RealtyMogul.com are intended for accredited investors (for persons
       residing in the U.S.) and for persons residing abroad in jurisdictions where securities
       registration exemptions are available. Securities sold in private placements are not
       publicly traded, are subject to holding period requirements, and are intended for investors
       who do not need a liquid investment. Private placement investments are NOT bank deposits (and
       thus NOT insured by the FDIC or by any other federal governmental agency), are NOT guaranteed
       by RealtyMogul or NCPS, and MAY lose value. Neither the Securities and Exchange Commission
       nor any federal or state securities commission or regulatory authority has recommended or
       approved any investment or the accuracy or completeness of any of the information or
       materials provided by or through the website. Investors must be able to afford to lose their
       entire investment.
        <br /><br />
       Mogul Securities, LLC, an affiliate of RealtyMogul, is a registered broker-dealer and member
        <a style={linkStyle} href="http://www.finra.org/"> FINRA</a>/
        <a style={linkStyle} href="http://www.sipc.org/">SIPC</a>.
       While Mogul Securities, LLC holds an active license, it is not currently engaged
       in the sale of securities.  It does, however, refer investment opportunities to NCPS.
       NCPS generally invoices the companies sponsoring real estate projects into which a
       RealtyMogul-organized company will invest for NCPS execution and other services.
       Mogul Securities, LLC is separately paid a referral fee by NCPS.  In addition, several
       officers and employees of RealtyMogul are registered representatives of NCPS and will receive
       compensation through NCPS as a result of their activities related to the private placement
       securities transactions conducted by NCPS.
        <br /><br />
        <Body type="B3" style={italicized}>Advisory Services</Body>
        <br /><br />
       RM Manager, LLC is a wholly-owned subsidiary of Realty Mogul, Co. and an exempt reporting
       adviser that serves as manager to several special purpose entities/private placements, each
       pursuing a venture capital strategy. RM Manager, LLC&apos;s clients are the special purpose
       entities it advises and not the investors in such entities.
        <br /><br />
        RM Adviser, LLC is a wholly-owned subsidiary of Realty Mogul, Co. and an
         SEC-registered investment adviser that serves as manager to our REIT
         offerings (Mogul REIT I, LLC and Mogul REIT II, Inc.) and single purpose
         funds. RM Adviser, {"LLC's"} clients are the REIT entities and single
         purpose funds, and not the investors in the REITs or the single purpose
         funds in their capacities as such.
        <br /><br />
        RealtyMogul does not make investment recommendations via this website,
        and no communication through this website or in any other medium should
        be construed as such.
        <br /><br />
       *Past performance is not indicative of future performance.
        <br /><br />
        <Heading type="H6">Investment Disclosure</Heading>
        <br /><br />
       Real estate return data is from FTSE NAREIT US Real Estate Index Series (All REITs),
       while S&P return data is from Morningstar, Inc. Real estate return data should not be used
       to estimate returns of RealtyMogul.com investments. While the FTSE NAREIT All REITs index
       covers all publicly traded REITs, all RealtyMogul.com investments are either private
       placements or non-traded REITs.  Moreover, individual RealtyMogul.com investments
       performance can vary significantly from the performance of REITs.
      </Body>
    </ExtendedFlex>
  );
};
export default Disclosure;
